<template>
  <div class="wallet-banner">
    <div class="d-flex align-items-start">
      <div class="me-4">
        <img :src="walletData?.user?.jersey" alt="" class="profile-pic" />
      </div>

      <div class="flex-grow-1 ml-4">
        <div class="d-flex align-items-center mb-3">
          <img
            v-if="walletData?.user?.countryFlag"
            :src="walletData?.user?.countryFlag"
            alt=""
            class="country-flag"
          />
          <h2 class="user-name me-3 mb-0">
            {{ walletData?.user?.name || "User" }}
          </h2>

          <span
            v-if="walletData?.user?.verificationStatus === 'pending'"
            class="badge badge-pending ml-4"
          >
            <i class="bi bi-info-circle-fill me-1"></i>
            Verification in progress
          </span>

          <span
            v-else-if="walletData?.user?.verificationStatus === 'rejected'"
            class="badge badge-danger ml-4"
          >
            <img src="/assets/images/wallet/xsign.png" class="xsign" />
            Rejected
          </span>

          <span
            v-else-if="walletData?.user?.verified"
            class="badge badge-success verified ml-4"
          >
            <img src="/assets/images/wallet/verified.png" class="check-sign" />
            verified
          </span>

          <span v-else class="badge ml-4">
            <img src="/assets/images/wallet/xsign.png" class="xsign" />
            unverified
          </span>
        </div>

        <div class="row balance-info p-3 align-items-center">
          <div class="col-md-8">
            <h3 class="total mb-2">Total Balance</h3>
            <p class="balance-value mb-3">
              {{ walletData?.walletData?.balance || "0.000000" }}
              {{ walletData?.walletData?.currency || "BTC" }}
            </p>
            <!-- <p class="usd-value mb-4">
              = ${{ //formatUSD(walletData?.walletData?.balanceUSD) }} USD
            </p> -->
          </div>
          <div class="col-md-4 d-flex align-items-center justify-content-end">
            <slot name="action-button">
              <button
                class="btn-universal"
                v-if="walletData?.user?.verificationStatus === 'unverified'"
                @click="$router.push('/wallet/account-verification')"
              >
                Verify Account
              </button>

              <button
                class="btn-universal"
                v-if="walletData?.user?.verificationStatus === 'rejected'"
                @click="$router.push('/wallet/account-verification')"
              >
                Reverify Account
              </button>

              <button
                class="btn btn-warning fw-bold wallet-btn"
                v-if="walletData?.user?.verificationStatus === 'approved'"
                @click="$router.push('/wallet/withdrawal-request')"
              >
                Withdraw
              </button>
            </slot>
          </div>
        </div>

        <p class="update-date mt-2">
          Last updated:
          {{ formatLastUpdated(walletData?.walletData?.lastUpdated) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WalletHeader",
  props: {
    walletData: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    formatUSD(value) {
      return parseFloat(value || 0).toFixed(2);
    },
    formatLastUpdated(date) {
      if (!date) return "Unknown";

      const now = new Date();
      const updateDate = new Date(date);

      // Check if it's today
      if (updateDate.toDateString() === now.toDateString()) {
        return `Today, ${updateDate.getHours()}:${String(
          updateDate.getMinutes()
        ).padStart(2, "0")} ${updateDate.getHours() >= 12 ? "PM" : "AM"}`;
      }

      // Check if it's yesterday
      const yesterday = new Date(now);
      yesterday.setDate(now.getDate() - 1);
      if (updateDate.toDateString() === yesterday.toDateString()) {
        return `Yesterday, ${updateDate.getHours()}:${String(
          updateDate.getMinutes()
        ).padStart(2, "0")} ${updateDate.getHours() >= 12 ? "PM" : "AM"}`;
      }

      // Otherwise return full date
      return `${updateDate.toLocaleDateString()}, ${updateDate.getHours()}:${String(
        updateDate.getMinutes()
      ).padStart(2, "0")} ${updateDate.getHours() >= 12 ? "PM" : "AM"}`;
    },
  },
};
</script>
<style scoped>
.badge.badge-pending {
  color: #c99400;
  background: rgba(201, 148, 0, 0.3);
  border: 1px solid #c99400;
}

.badge.badge-danger {
  color: #dc3545;
  background: rgba(220, 53, 69, 0.1);
  border: 1px solid #dc3545;
}
</style>
<template>
  <div class="wallet-banner">
    <div class="d-flex align-items-start">
      <div class="me-4">
        <img :src="walletData?.user?.jersey" alt="" class="profile-pic" />
      </div>

      <div class="flex-grow-1 ml-4">
        <div class="d-flex align-items-center mb-3">
          <img
            v-if="walletData?.user?.countryFlag"
            :src="walletData?.user?.countryFlag"
            alt=""
            class="country-flag"
          />
          <h2 class="user-name me-3 mb-0">
            {{ walletData?.user?.name || "User" }}
          </h2>

          <span
            v-if="walletData?.user?.verificationStatus === 'pending'"
            class="badge badge-pending ml-4"
          >
            <i class="bi bi-info-circle-fill me-1"></i>
            Verification in progress
          </span>

          <span
            v-else-if="walletData?.user?.verificationStatus === 'rejected'"
            class="badge badge-danger ml-4"
          >
            <img src="/assets/images/wallet/xsign.png" class="xsign" />
            Rejected
          </span>

          <span
            v-else-if="walletData?.user?.verified"
            class="badge badge-success verified ml-4"
          >
            <img src="/assets/images/wallet/verified.png" class="check-sign" />
            verified
          </span>

          <span v-else class="badge ml-4">
            <img src="/assets/images/wallet/xsign.png" class="xsign" />
            unverified
          </span>
        </div>

        <div class="row balance-info p-3 align-items-center">
          <div class="col-md-8">
            <h3 class="total mb-2">Total Balance</h3>
            <p class="balance-value mb-3">
              {{ walletData?.walletData?.balance || "0.000000" }}
              {{ walletData?.walletData?.currency || "BTC" }}
            </p>
            <!-- <p class="usd-value mb-4">
              = ${{ //formatUSD(walletData?.walletData?.balanceUSD) }} USD
            </p> -->
          </div>
          <div class="col-md-4 d-flex align-items-center justify-content-end">
            <slot name="action-button">
              <button
                class="btn-universal"
                v-if="walletData?.user?.verificationStatus === 'unverified'"
                @click="$router.push('/wallet/account-verification')"
              >
                Verify Account
              </button>

              <button
                class="btn-universal"
                v-if="walletData?.user?.verificationStatus === 'rejected'"
                @click="$router.push('/wallet/account-verification')"
              >
                Reverify Account
              </button>

              <button
                class="btn btn-warning fw-bold wallet-btn"
                v-if="walletData?.user?.verificationStatus === 'approved'"
                @click="$router.push('/wallet/withdrawal-request')"
              >
                Withdraw
              </button>
            </slot>
          </div>
        </div>

        <p class="update-date mt-2">
          Last updated:
          {{ formatLastUpdated(walletData?.walletData?.lastUpdated) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WalletHeader",
  props: {
    walletData: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    formatUSD(value) {
      return parseFloat(value || 0).toFixed(2);
    },
    formatLastUpdated(date) {
      if (!date) return "Unknown";

      const now = new Date();
      const updateDate = new Date(date);

      // Check if it's today
      if (updateDate.toDateString() === now.toDateString()) {
        return `Today, ${updateDate.getHours()}:${String(
          updateDate.getMinutes()
        ).padStart(2, "0")} ${updateDate.getHours() >= 12 ? "PM" : "AM"}`;
      }

      // Check if it's yesterday
      const yesterday = new Date(now);
      yesterday.setDate(now.getDate() - 1);
      if (updateDate.toDateString() === yesterday.toDateString()) {
        return `Yesterday, ${updateDate.getHours()}:${String(
          updateDate.getMinutes()
        ).padStart(2, "0")} ${updateDate.getHours() >= 12 ? "PM" : "AM"}`;
      }

      // Otherwise return full date
      return `${updateDate.toLocaleDateString()}, ${updateDate.getHours()}:${String(
        updateDate.getMinutes()
      ).padStart(2, "0")} ${updateDate.getHours() >= 12 ? "PM" : "AM"}`;
    },
  },
};
</script>
<style scoped>
.badge.badge-pending {
  color: #c99400;
  background: rgba(201, 148, 0, 0.3);
  border: 1px solid #c99400;
}

.badge.badge-danger {
  color: #dc3545;
  background: rgba(220, 53, 69, 0.1);
  border: 1px solid #dc3545;
}
</style>
